if (!customElements.get('free-shipping-threshold')) {
  customElements.define('free-shipping-threshold', class FreeShippingThreshold extends HTMLElement {
    constructor() {
      super();

      let template = this.getElementsByTagName("template")[0];
      let templateContent = template.content;
      const shadowRoot = this.attachShadow({ mode: "open" });
      shadowRoot.appendChild(templateContent.cloneNode(true));
    }

    connectedCallback() {
      const shadowRoot = this.shadowRoot;
      const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: Shopify.currency.active,
        currencyDisplay: 'narrowSymbol'
      });
      let threshold = this.getAttribute("data-threshold");
      threshold *= Shopify.currency.rate;
      const cartTotal = this.getAttribute("data-cart-total");
      const difference = threshold - cartTotal;
      const line = shadowRoot.querySelector("hr")

      if (difference > 0) {
        const freeShippingBar = shadowRoot.querySelector(".free-shipping-bar__bar-inner");
        const thresholdText = shadowRoot.querySelector("[slot='threshold-text']");
        thresholdText.innerHTML = formatter.format(difference / 100);
        freeShippingBar.style.width = `${cartTotal / threshold * 100}%`;
        line.style.display = "none";
      } else {
        const text = shadowRoot.querySelector("[slot='text']");
        const freeShippingBarOuter = shadowRoot.querySelector(".free-shipping-bar__bar");
        text.innerHTML = this.getAttribute("data-free-shipping-reached");
        freeShippingBarOuter.style.display = "none";
        line.style.display = "block";
      }

    }

  });
}
